<style scoped lang="scss">
  @import "../user";
  @import "./ipone";
  .dd_one{
    overflow: auto;
  }
  .dd_two{
    display: none;
  }
  .order{
    border: 1px solid #E4E6EA;
    margin-top: 20px;
    .top{
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #E4E6EA;
      padding:10px 15px;
      dl{
        display: flex;
        dd{
          margin-right: 40px;
        }
      }
      .status{
        color: #014492;
        font-weight: bold;
      }
    }
    .products{
      li{
        display: flex;
        align-items: center;
        padding:20px;
        border-bottom: 1px solid #E4E6EA;
        &:last-child{
          border-bottom: 0;
        }
        .img-box{
          width:106px;
          height:106px;
          float: left;
          margin-right: 20px;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          .redFlag {
            background: #FF2E2E;
            color: #fff;
            width: 106px;
            position: absolute;
            z-index: 50;
            text-align: center;
            font-size: 11px;
            line-height: 18px;
            margin-bottom: -85px;
          }
          img{
            width: 100%;
            height:100%;
          }
        }
        .info{
          flex:1;
        }
        .title{
          font-size: 16px;
        }
      }
      dl{
        display: flex;
        flex-wrap: wrap;
        dd{
          width:25%;
          margin-top:8px;
          label{
            color:#999;
          }
        }
      }
      &.multi{
        dl{
          dd{
            width:33.33%;
          }
        }
      }
    }
  }
  .products-lists{
    display: flex;
    .products{
      flex:1;
      border-right:1px solid #E4E6EA;
    }
    .status{
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding:0 10px;
      text-align: center;
      flex-shrink: 0;
      width:150px;
      dl{
        label{
          color:#999;
        }
        dd{
          display: block;
          margin:10px 0;
        }
      }
    }
  }
  .product{
    display: flex;
    align-items: center;
    .info{
      margin-left: 20px;
      text-align: left;
      flex:1;
    }
    .title{
      font-size: 16px;
      font-weight: bold;
    }
  }
  .el-input-number{
    width:120px;
  }
  @media
  screen and (max-width: 375px) and (min-width: 374px),
  screen and (max-width: 414px) and (min-width: 413px),
  screen and (max-width: 640px) and (min-width: 600px),
  screen and (min-width: 300px) and (max-width:400px)
  {
    .order .products li .img-box{
      float: none!important;
    }
  }
  .exchange {
    background-color: #70b603;
    padding: 3px 5px;
    border-radius: 15px;
    color: #fff;
    margin-left: 5px;
  }

</style>
<template>
  <div class="user" v-loading="loading">
    <section>
      <h3 class="title">擎科科邦邦商城订单</h3>
      <div class="search-form">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <!-- <el-button @click="deliveryReminder">1213</el-button> -->
          <el-form-item label="关联用户：" v-if="isHeadMan">
            <el-select v-model="searchForm.customerId" filterable clearable>
              <el-option
                v-for="item in courseInfo.members"
                :key="item.id"
                :label="item.realName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单号：">
            <el-input v-model="searchForm.orderNo" placeholder="请输入订单号"></el-input>
          </el-form-item>
          <el-form-item label="时间：" class="date">
            <el-date-picker
              v-model="searchForm.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="bindSearch"  class="search-button">搜索</el-button>
          </el-form-item>
        </el-form>
        订单状态：
        <el-radio-group v-model="status" @change="getOrders">
          <el-radio label="">全部</el-radio>
          <el-radio label="PART_SEND">部分发货</el-radio>
          <el-radio label="FINISHED">全部发货</el-radio>
          <el-radio label="CANCEL">订单取消</el-radio>
          <el-radio label="NEED_CONFIRM">待提交</el-radio>
        </el-radio-group>
      </div>
      <div class="order" v-for="(item, index) in orderLists" :key="item.id">
        <div class="top">
          <dl class="info">
            <dd @click="toOrderDetails(item.id)" class="dd_one pointer">订单编号：<span class="text-primary">{{item.code}}</span></dd>
            <dd @click="toOrderDetails(item.id)" class="dd_two pointer">订单编号：<br><span class="text-primary">{{item.code}}</span></dd>
            <dd class="dd_one">下单时间：{{item.createTime | rTime}}</dd>
            <dd class="dd_two">下单时间：<br/>{{item.createTime | rTime}}</dd>
            <dd>订单应付金额：{{item.amount | amount}} 元</dd>
          </dl>
<!--          <span class="status">{{item.statusName}}</span>-->
              <el-button type="primary" size="small" v-show="item.exchangeGoodsFlag" @click="exchangeOrder(item)">确认换货</el-button>
              <el-button type="primary" size="small" v-show="item.statusName === '待提交' && memberInfo.id === item.customer.id" @click="confirmOrder(index)">提交订单</el-button>
              <el-button type="primary" size="small" v-show="['待提交','待审核'].indexOf(item.statusName) > -1 && memberInfo.id === item.customer.id" @click="cancel(index)">取消订单</el-button>
              <el-tooltip content="该订单换货信息尚未确认，请客户确认后再发货" placement="top" effect="light" :disabled="!item.exchangeGoodsFlag">
              <el-button type="primary" size="small" v-show="item.retainGoods && ['待提交','待审核','订单取消'].indexOf(item.statusName) < 0 && memberInfo.id === item.customer.id" 
                @click="openSend(index)" 
                :disabled="item.exchangeGoodsFlag"
              >发货</el-button>
              </el-tooltip>
              <!-- <el-button type="primary" size="small"  @click="openSend(index)">发货</el-button> -->
        </div>
        <!--多商品情况-->
        <div class="products-lists" v-if="item.items.length > 1">
          <ul class="products multi">
            <li v-for="itx in item.items" :key="itx.id">
              <div v-if="itx.goods" style="width: 100%;">
              <div class="img-box">
                <div v-if="itx.syzFlag / 1 === syzStatus" class="redFlag">试用装</div>
                <div v-else-if="itx.price==0" class="redFlag">赠品</div>
                <img v-if="itx.goods!==null" :src="itx.goods.mainImgUrl">
                <img v-else :src="itx.imgUrl"/>
              </div>
              <div class="info">
                <div class="title pointer" style="color: #409EFF;" @click="shopOrderDetails(itx)">{{itx.name}}</div>
                <div class="dd_one">
                <dl>
                  <dd>
                    <label>规格：</label>{{itx.spec}}
                    <span class="exchange" v-if="item.exchangeGoodsTypeFlag">换</span>
                  </dd>
                  <dd><label>数量：</label>{{itx.needPayQuantity}}</dd>
                  <dd><label>未发货数量：</label><span class="text-primary">{{itx.needSendQuantity}}</span></dd>
                  <dd><label>单位：</label>{{itx.skuUnit}}</dd>
                  <dd><label>货号：</label>{{itx.skuCode}}</dd>dd
                  <dd><label>单价（元）：</label>{{itx.priceY | regDecimalPoint}}</dd>
<!--                  <dd><label>应付金额（元）：</label>{{itx.needPayQuantity * itx.price | amount}}</dd>-->
                </dl>
                </div>
                <div class="dd_two">
                  <dl>
                    <dd>
                      <label>规格：</label>{{itx.spec}}
                      <span class="exchange" v-if="item.exchangeGoodsTypeFlag">换</span>
                    </dd>
                    <dd><label>数量：</label>{{itx.needPayQuantity}}</dd>
                    <dd><label>未发货数量：</label><span class="text-primary">{{itx.needSendQuantity}}</span></dd>
                    <dd><label>单位：</label>{{itx.skuUnit}}</dd>
                    <dd><label>货号：</label>{{itx.skuCode}}</dd>
                    <dd><label>单价：</label>￥{{itx.priceY | regDecimalPoint}}</dd>
<!--                    <dd><label>应付金额：</label>￥{{itx.needPayQuantity * itx.price | amount}}</dd>-->
                  </dl>
                </div>
              </div>
              </div>
              <div v-if="!itx.goods" style="width: 100%;">
                <div class="img-box">
                  <img :src="itx && itx.imgUrl">
                  <div v-if="itx.syzFlag / 1 === syzStatus" class="redFlag">试用装</div>
                  <div v-else-if="itx.price==0" class="redFlag">赠品</div>
                </div>
                <div class="info">
                  <div class="title pointer" style="color: #409EFF;" @click="shopOrderDetails(itx)">{{itx.name}}</div>
                  <div class="dd_one">
                    <dl>
                      <dd>
                        <label>规格：</label>{{itx.spec}}
                        <span class="exchange" v-if="item.exchangeGoodsTypeFlag">换</span>
                      </dd>
                      <dd><label>数量：</label>{{itx.needPayQuantity}}</dd>
                      <dd><label>未发货数量：</label><span class="text-primary">{{itx.needSendQuantity}}</span></dd>
                      <dd><label>单位：</label>{{itx.skuUnit}}</dd>
                      <dd><label>货号：</label>{{itx.skuCode}}</dd>
                      <dd><label>单价（元）：</label>{{itx.priceY | regDecimalPoint}}</dd>
<!--                      <dd><label>应付金额（元）：</label>{{itx.needPayQuantity * itx.price | amount}}</dd>-->
                    </dl>
                  </div>
                  <div class="dd_two">
                    <dl>
                      <dd>
                        <label>规格：</label>{{itx.spec}}
                        <span class="exchange" v-if="item.exchangeGoodsTypeFlag">换</span>
                      </dd>
                      <dd><label>数量：</label>{{itx.needPayQuantity}}</dd>
                      <dd><label>未发货数量：</label><span class="text-primary">{{itx.needSendQuantity}}</span></dd>
                      <dd><label>单位：</label>{{itx.skuUnit}}</dd>
                      <dd><label>货号：</label>{{itx.skuCode}}</dd>
                      <dd><label>单价：</label>￥{{itx.priceY | regDecimalPoint}}</dd>
<!--                      <dd><label>应付金额：</label>￥{{itx.needPayQuantity * itx.price | amount}}</dd>-->
                    </dl>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div class="status">
            <dl>
              <dd v-show="isHeadMan"><label>关联用户：</label>{{item.customer.realName}}</dd>
              <dd><label>订单状态：</label>{{item.statusName}}</dd>
            </dl>
          </div>
        </div>
        <!--单商品情况-->
        <div class="products-lists" v-else>
          <ul class="products">
            <li>
              <div v-if="item.items[0].goods" style="width: 100%;">
              <div class="img-box">
                <div v-if="item.items[0].goods.syzFlag / 1 === syzStatus" class="redFlag">试用装</div>                
                <div v-else-if="item.items[0].price==0" class="redFlag">赠品</div>
                <img v-if="item.items[0].goods !== null" :src="item.items[0].goods.mainImgUrl"/>
                <img v-else :src="item.items[0].imgUrl"/>
              </div>
              <div class="info">
                <div class="title pointer" style="color: #409EFF" @click="shopOrderDetails(item.items[0])">{{item.items[0].name}}</div>
                <div class="dd_two">
                  <dl>
                    <dd>
                      <label>规格：</label>{{item.items[0].spec}}
                      <span class="exchange" v-if="item.exchangeGoodsTypeFlag">换</span>
                    </dd>
                    <dd><label>数量：</label>{{item.needPayQuantity}}</dd>
                    <dd><label>未发货数量：</label><span class="text-primary">{{item.items[0].needSendQuantity}}</span></dd>
                    <dd><label>单位：</label>{{item.items[0].skuUnit}}</dd>
                    <dd><label>货号：</label>{{item.items[0].skuCode}}</dd>
                    <dd><label>单价：</label>￥{{item.items[0].priceY | regDecimalPoint}}</dd>
<!--                    <dd><label>应付金额：</label>￥{{item.items[0].needPayQuantity * item.items[0].priceY | amount}}</dd>-->
                    <dd v-show="isHeadMan"><label>关联用户：</label>{{item.customer.realName}}</dd>
                    <dd><label>订单状态：</label>{{item.statusName}}</dd>
                  </dl>
                </div>
                <div class="dd_one">
                  <dl>
                    <dd>
                      <label>规格：</label>{{item.items[0].spec}}
                      <span class="exchange" v-if="item.exchangeGoodsTypeFlag">换</span>
                    </dd>
                    <dd><label>数量：</label>{{item.needPayQuantity}}</dd>
                    <dd><label>订单状态：</label>{{item.statusName}}</dd>
                    <dd><label>单位：</label>{{item.items[0].skuUnit}}</dd>
                    <dd><label>货号：</label>{{item.items[0].skuCode}}</dd>
                    <dd><label>单价：</label>{{item.items[0].priceY | regDecimalPoint}}</dd>
<!--                    <dd><label>应付金额：</label>{{item.items[0].needPayQuantity * item.items[0].price | amount}}</dd>-->
                    <dd v-show="isHeadMan"><label>关联用户：</label>{{item.customer.realName}}</dd>
                    <dd><label>未发货数量：</label><span class="text-primary">{{item.items[0].needSendQuantity}}</span></dd>
                  </dl>
                </div>

              </div>
              </div>
              <div v-if="!item.items[0].goods" style="width: 100%;">
                <div class="img-box">
                  <div v-if="item.items[0].syzFlag / 1 === syzStatus" class="redFlag">试用装</div>
                  <div v-else-if="item.items[0].price==0" class="redFlag">赠品</div>
                  <img :src="item.items[0].imgUrl">
                </div>
                <div class="info">
                  <div class="title pointer" style="color: #409EFF" @click="shopOrderDetails(item.items[0])">{{item.items[0].name}}</div>
                  <div class="dd_two">
                    <dl>
                      <dd>
                        <label>规格：</label>{{item.items[0].spec}}
                        <span class="exchange" v-if="item.exchangeGoodsTypeFlag">换</span>
                      </dd>
                      <dd><label>数量：</label>{{item.needPayQuantity}}</dd>
                      <dd><label>未发货数量：</label><span class="text-primary">{{item.items[0].needSendQuantity}}</span></dd>
                      <dd><label>单位：</label>{{item.items[0].skuUnit}}</dd>
                      <dd><label>货号：</label>{{item.items[0].skuCode}}</dd>

                      <dd><label>单价：</label>￥{{item.items[0].priceY | regDecimalPoint}}</dd>
<!--                      <dd><label>应付金额：</label>￥{{item.items[0].needPayQuantity * item.items[0].price | amount}}</dd>-->
                      <dd v-show="isHeadMan"><label>关联用户：</label>{{item.customer.realName}}</dd>
                      <dd><label>订单状态：</label>{{item.statusName}}</dd>
                    </dl>
                  </div>
                  <div class="dd_one">
                    <dl>
                      <dd>
                        <label>规格：</label>{{item.items[0].spec}}
                        <span class="exchange" v-if="item.exchangeGoodsTypeFlag">换</span>
                      </dd>
                      <dd><label>数量：</label>{{item.needPayQuantity}}</dd>
                      <dd><label>订单状态：</label>{{item.statusName}}</dd>
                      <dd><label>单位：</label>{{item.items[0].skuUnit}}</dd>
                      <dd><label>货号：</label>{{item.items[0].skuCode}}</dd>
                      <dd><label>单价：</label>{{item.items[0].priceY | regDecimalPoint}}</dd>
<!--                      <dd><label>应付金额：</label>{{item.items[0].needPayQuantity * item.items[0].price | amount}}</dd>-->
                      <dd v-show="isHeadMan"><label>关联用户：</label>{{item.customer.realName}}</dd>
                      <dd><label>未发货数量：</label><span class="text-primary">{{item.items[0].needSendQuantity}}</span></dd>
                    </dl>
                  </div>

                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="no-data" v-show="orderLists.length === 0">暂无匹配订单信息</div>
      <div class="page tr" v-show="orderLists.length > 0">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          @current-change="changePage">
        </el-pagination>
      </div>
    </section>
    <!--发货弹出框-->
    <el-dialog
      title="商品提交发货"
      :visible.sync="sendVisible"
      width="60%">
      <el-table
        class="mt20"
        max-height="660"
        :data="goodsLists">
        <el-table-column
          prop="money"
          label="产品信息">
          <template slot-scope="scope">
            <div class="product">
              <img :src="scope.row.imgUrl" style="width:80px;">
              <div class="info">
                <div class="title">{{scope.row.name}}</div>
                <p>规格：{{scope.row.spec}}</p>
                <p>货号：{{scope.row.skuCode}}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="未发货商品数量">
          <template slot-scope="scope">
            {{scope.row.needSendQuantity}}
          </template>
        </el-table-column>
        <el-table-column
          label="本次发货数量">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.sendNums" controls-position="right" :min="0" :max="scope.row.needSendQuantity"></el-input-number>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sendVisible = false">取消</el-button>
        <el-button type="primary" :disabled="saveStatus" :loading="saveStatus" @click="bindSend">{{saveStatus?'提交中':'提交发货'}}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="发货提示"
      :visible.sync="deliveryReminderDia"
      width="400px"
      center
      :before-close="()=>{deliveryReminderDia = false}">
      <span>温馨提示：您发货的商品 <span v-for="(ele,idx) in tradeNames" :key="idx">【{{ele}}】</span> 需要进行调货，擎小科将分2次给您配送，给您带来不便敬请谅解，如有问题请联系销售人员！</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deliveryReminderDia = false">关闭（{{colseTime}}s）</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { productOrders, deleteProductOrders, productOrdersSend, productOrderscancel, productOrdersConfirm, confirmExchangeGoods } from '@/services/api.index'
import { MessageBox } from 'element-ui'
export default {
  data() {
    return {
      tradeNames:[],
      syzStatus: 1,
      saveStatus: false,
      sendVisible: false,
      searchForm: {
        customerId: '',
        orderNo: '',
        date: null
      },
      status: '',
      orderLists: [],
      goodsLists: [],
      sendOrderId: '',
      total: 0,
      page: 0,
      pageSize: 10,
      isHeadMan: this.baseMethods.isHeadMan(),
      courseInfo: this.baseMethods.getLocalObj('courseInfo'),
      memberInfo: this.baseMethods.getLocalObj('memberInfo'),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6 // 如果没有后面的-8.64e6就是不可以选择今天的
        }
      },
      deliveryReminderDia: false,
      colseTime:3,
      deliveryRemindeTimer: null,
      loading: false,
    }
  },
  watch:{
    deliveryReminderDia(val){
       if(!val){
         clearInterval(this.deliveryRemindeTimer)
         this.colseTime = 3
       }
    }
  },
  created() {
    this.getOrders(0)
  },
  methods: {
    cancel(val) {
      const h = this.$createElement
      MessageBox({
        title: '提示',
        message: h('p', null, [
          h('h2', {style: 'text-align:center'}, '确定取消订单? '),
          h('div', {style: 'text-align:center'}, '请谨慎操作'),
          h('div', {style: 'text-align:center'}, '确定后，将取消订单，不可撤销')
        ]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '执行中...'
            setTimeout(() => {
              done()
              setTimeout(() => {
                instance.confirmButtonLoading = false
              }, 300)
            }, 2000)
          } else {
            done()
          }
        }
      }).then(() => {
        this.sendOrderId = this.orderLists[val].id
        productOrderscancel(this.sendOrderId).then(() => {
          this.$message.success('操作成功！')
          this.getOrders()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    confirmOrder(val) {
      MessageBox({
        title: '提示',
        message: '是否提交该笔订单？',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '执行中...'
            setTimeout(() => {
              done()
              setTimeout(() => {
                instance.confirmButtonLoading = false
              }, 300)
            }, 2000)
          } else {
            done()
          }
        }
      }).then(() => {
        this.sendOrderId = this.orderLists[val].id
        productOrdersConfirm(this.sendOrderId).then(() => {
          this.$message.success('订单提交成功！')
          this.getOrders()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    async exchangeOrder({id}) {
      await this.$confirm("是否确认换货?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      this.loading = true;
      try {
        await confirmExchangeGoods(id)
        this.$message.success('订单换货成功！')
        this.getOrders()
      } catch (error) {
        this.$message.error(error.replace(/[^\u4e00-\u9fa5]/g, ''));
      }
      this.loading = false
    },
    openSend (index) {
      this.sendVisible = true
      this.goodsLists = this.orderLists[index].items
      this.sendOrderId = this.orderLists[index].id
    },
    deliveryReminder(){
      this.deliveryReminderDia = true
      this.colseTime = 3
      this.deliveryRemindeTimer = setInterval(()=>{
        this.colseTime -= 1
        if(this.colseTime==0){
          this.deliveryReminderDia = false
          clearInterval(this.deliveryRemindeTimer)
        }
      },1000)
    },
    // 确认发货
    bindSend () {
      let items = []
      const sendGoods = this.goodsLists.filter(item => item.sendNums > 0)
      if (sendGoods.length === 0) {
        this.$message.error('请添加发货商品数量')
        return
      }
      this.goodsLists.map(item => {
        if (item.sendNums > 0) {
          items = items.concat({
            orderItemId: item.id,
            sendQuantity: Number(item.sendNums)
          })
        }
      })
      this.saveStatus = true
      productOrdersSend(this.sendOrderId, items).then((res) => {
        if(res.data.orderItemNames && res.data.orderItemNames.length>0){
            this.tradeNames = res.data.orderItemNames
            this.deliveryReminder()
        }
        this.sendVisible = false
        this.saveStatus = false
        this.$message.success('提交发货成功！')
        this.getOrders()
      })
    },
    // 订单列表
    getOrders () {
      const { page, pageSize, status } = this
      let { customerId, orderNo, date } = this.searchForm
      date = date || ['', '']
      productOrders(page, pageSize, orderNo, ...date, status, customerId).then(res => {
        res.data.map(item => {
          // item.statusName = item.retainGoods ? '部分发货' : '全部发货'
          item.statusName = this.baseMethods.molecularOrderStatus(item.webStatus)
          item.items.map(itx => {
            itx.sendNums = 0
          })
        })
        this.orderLists = res.data
        this.total = this.baseMethods.getTotal(res)
        console.log('555', this.orderLists)
      })
    },
    bindSearch () {
      this.page = 0
      this.getOrders()
    },
    // 订单详情
    toOrderDetails(id) {
      this.$router.push(`/user/molecular_details?id=${id}`)
    },
    // 商城订单详情
    shopOrderDetails: function (detail) {
      console.info('detail data.', detail)
      window.open(process.env.SHOP_URL + `/product/detail/${detail.shopId ? detail.shopId : detail.id}`)
      // if (detail.goods !== null && detail.goods.shopId !== null) {
      //   window.open(process.env.SHOP_URL + `/product/detail/${detail.goods.shopId}`)
      // } else {
      //   window.open(process.env.SHOP_URL + `/product/detail/${detail.shopId}`)
      // }
    },
    // 删除订单
    bindDelete (id) {
      deleteProductOrders(id).then(() => {
        this.$message.success('删除成功！')
        this.getOrders()
      })
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getOrders()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/children/molecular.vue